import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export type Params = {
  companyName: string
  companyEmail: string
  companyPhone: string
  companySlogan: string
  showContactPhone: boolean
  showContactEmail: boolean
  showEtaRange: boolean
  showPicturePod: boolean
  showSignaturePod: boolean
  showAudioPod: boolean
  showNotePod: boolean
}

/**
 * Update the Almost There notification config.
 */
export const buildTrackingPagePreviewUrl = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/buildTrackingPagePreviewUrl', async (payload: Params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/territory/buildTrackingPagePreviewUrl', {
      category: 'rpc',
      type: 'rpc/territory/buildTrackingPagePreviewUrl',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {buildTrackingPagePreviewUrl}`,
      { tags: ['rpc', 'territory'], info: error },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update of mobile app interaction failed`,
      error,
    })
  }
})
